// The contact details every booking form asks for, with one set of validation rules (assessment and catalog).
import { createBaseTextSchema, safeEmailSchema } from "./fieldValidation";

export type ContactField = "firstName" | "lastName" | "jobTitle" | "company" | "email";

const nameRule = { min: 2, max: 50, allowedPattern: /^[a-zA-Z\s'-]+$/ };
const schemas: Record<ContactField, { validateSync: (value: string) => unknown }> = {
  firstName: createBaseTextSchema({ label: "First name", ...nameRule,
    allowedPatternMessage: "First name can only contain letters, spaces, hyphens, and apostrophes" }),
  lastName: createBaseTextSchema({ label: "Last name", ...nameRule,
    allowedPatternMessage: "Last name can only contain letters, spaces, hyphens, and apostrophes" }),
  jobTitle: createBaseTextSchema({ label: "Job title", min: 2, max: 100, allowedPattern: /^[a-zA-Z0-9\s&'.,\-()/]+$/,
    allowedPatternMessage: "Job title can only contain letters, numbers, spaces, and basic punctuation" }),
  company: createBaseTextSchema({ label: "Company", min: 2, max: 100, allowedPattern: /^[a-zA-Z0-9\s&'.,\-()/]+$/,
    allowedPatternMessage: "Company name contains invalid characters" }),
  email: safeEmailSchema(),
};

// Dashboard field names -> form fields, for server-side validation messages.
export const SERVER_FIELDS: Record<string, ContactField> = {
  first_name: "firstName", last_name: "lastName", job_title: "jobTitle", company: "company", email: "email",
};

export const CONTACT_FIELDS: { name: ContactField; label: string; autoComplete: string; inputMode?: "email" }[] = [
  { name: "firstName", label: "First name", autoComplete: "given-name" },
  { name: "lastName", label: "Last name", autoComplete: "family-name" },
  { name: "jobTitle", label: "Job title", autoComplete: "organization-title" },
  { name: "company", label: "Company", autoComplete: "organization" },
  { name: "email", label: "Work email", autoComplete: "email", inputMode: "email" },
];

export const emptyContact: Record<ContactField, string> = {
  firstName: "", lastName: "", jobTitle: "", company: "", email: "",
};

export function validateContact(form: Record<ContactField, string>): Partial<Record<ContactField, string>> {
  const found: Partial<Record<ContactField, string>> = {};
  for (const field of Object.keys(schemas) as ContactField[]) {
    try {
      schemas[field].validateSync(field === "email" ? form.email.trim().toLowerCase() : form[field].trim());
    } catch (error) {
      found[field] = error instanceof Error ? error.message : "Invalid input";
    }
  }
  return found;
}

export const secondaryButton =
  "inline-flex items-center justify-center rounded-full border border-borderSubtle bg-white px-6 py-3 font-semibold text-text-primary hover:bg-surfaceSoft disabled:opacity-60";
export const primaryButton =
  "inline-flex items-center justify-center rounded-full bg-primary px-8 py-3 font-semibold text-text-inverse hover:bg-primaryHover disabled:cursor-not-allowed disabled:opacity-60";
